import { IDateRange } from '@/components/BankStatementExport/types.ts';
import { ReasonNotNeededEnum } from '@/generated/graphql.ts';

export enum TransactionTypeEnum {
    Incoming = 'incoming',
    Outcoming = 'outcoming',
}

export enum TransactionTypeStatus {
  Processed = 'PROCESSED',
  Pending = 'PENDING',
}

export enum TransactionDocumentRequestInitiator {
  ACCOUNTANT = 'accountant',
  USER = 'user',
}

export const reasonNotNeededLabels: Record<ReasonNotNeededEnum, string> = {
  [ReasonNotNeededEnum.BankOrPlatformFee]: 'Bank or platform fee',
  [ReasonNotNeededEnum.ECommercePayout]: 'E-commerce payout',
  [ReasonNotNeededEnum.GovernmentOrTaxPayment]: 'Government or tax payment',
  [ReasonNotNeededEnum.InternalTransfer]: 'Internal transfer',
  [ReasonNotNeededEnum.SalaryOrDirectorPayment]: 'Salary or director payment',
  [ReasonNotNeededEnum.BankInterest]: 'Bank interest',
  [ReasonNotNeededEnum.Cashback]: 'Cashback',
};

export interface ITransactionFilters {
  transactionDocConnections?: boolean | null;
  transactionType?: TransactionTypeEnum | null;
  search?: string | null;
  accountId?: string | null;
  missingDocuments?: boolean | null;
}

export interface IFetchTransactionsParams {
  companyId: string;
  page: number;
  rowsPerPage: number;
  periodId?: string;
  filters?: ITransactionFilters;
  dateRange?: IDateRange;
}

export interface OptionTransactionType {
  label: string;
  value: TransactionTypeEnum | null;
}

export interface Currency {
  code: string;
  symbol: string;
}

export interface IToggleContainedDocumentsOption {
  value: boolean | null;
  slot: string;
}

export enum TransactionsMode {
  Period = 'period',
  Default = 'default',
}

export enum TransactionAction {
  Mark = 'mark',
  Unmark = 'unmark'
}

export const currencies: Currency[] = [
  { code: 'EUR', symbol: '€' },
  { code: 'USD', symbol: '$' },
  { code: 'GBP', symbol: '£' },
  { code: 'PLN', symbol: 'zł' },
  { code: 'THB', symbol: '฿' },
  { code: 'SEK', symbol: 'kr' },
  { code: 'DKK', symbol: 'kr' },
  { code: 'ALL', symbol: 'L' },
  { code: 'DZD', symbol: '.د.ج' },
  { code: 'AOA', symbol: 'Kz' },
  { code: 'AZN', symbol: '₼' },
  { code: 'ARS', symbol: '$' },
  { code: 'AMD', symbol: '֏' },
  { code: 'AWG', symbol: 'ƒ' },
  { code: 'AFN', symbol: '؋' },
  { code: 'BSD', symbol: '$' },
  { code: 'BDT', symbol: '৳' },
  { code: 'BBD', symbol: '$' },
  { code: 'BHD', symbol: '.د.ب ' },
  { code: 'BZD', symbol: '$' },
  { code: 'BYN', symbol: 'Br' },
  { code: 'BMD', symbol: '$' },
  { code: 'BGN', symbol: 'лв' },
  { code: 'BOB', symbol: '$' },
  { code: 'BAM', symbol: 'KM' },
  { code: 'BWP', symbol: 'P' },
  { code: 'BRL', symbol: '$' },
  { code: 'BND', symbol: '$' },
  { code: 'BIF', symbol: '₣' },
  { code: 'BTN', symbol: 'Nu' },
  { code: 'VUV', symbol: 'Vt' },
  { code: 'HUF', symbol: 'Ft' },
  { code: 'VES', symbol: 'Bs. S.' },
  { code: 'VND', symbol: '₫' },
  { code: 'HTG', symbol: 'G' },
  { code: 'GYD', symbol: '$' },
  { code: 'GMD', symbol: 'D' },
  { code: 'GHS', symbol: '₵' },
  { code: 'GTQ', symbol: 'Q' },
  { code: 'GNF', symbol: '₣' },
  { code: 'GIP', symbol: '£' },
  { code: 'HNL', symbol: 'L' },
  { code: 'HKD', symbol: '$' },
  { code: 'GEL', symbol: '₾' },
  { code: 'DJF', symbol: '₣' },
  { code: 'DOP', symbol: '$' },
  { code: 'EGP', symbol: '.ج.م' },
  { code: 'ZMW', symbol: 'K' },
  { code: 'ZWL', symbol: 'Z$' },
  { code: 'ILS', symbol: '₪' },
  { code: 'INR', symbol: '₹' },
  { code: 'IDR', symbol: '₨' },
  { code: 'JOD', symbol: '.د.إ' },
  { code: 'IQD', symbol: '.د.ع ' },
  { code: 'IRR', symbol: '﷼' },
  { code: 'ISK', symbol: 'kr' },
  { code: 'YER', symbol: '﷼' },
  { code: 'CVE', symbol: '$' },
  { code: 'KZT', symbol: '₸' },
  { code: 'KYD', symbol: '$' },
  { code: 'KHR', symbol: '៛' },
  { code: 'CAD', symbol: '$' },
  { code: 'QAR', symbol: '﷼' },
  { code: 'KES', symbol: 'KSh' },
  { code: 'KGS', symbol: 'с' },
  { code: 'CNY', symbol: '¥' },
  { code: 'COP', symbol: '$' },
  { code: 'KMF', symbol: '₣' },
  { code: 'CDF', symbol: '₣' },
  { code: 'KPW', symbol: '₩' },
  { code: 'KRW', symbol: '₩' },
  { code: 'CRC', symbol: '₡' },
  { code: 'CUP', symbol: '$' },
  { code: 'KWD', symbol: '.د.ك' },
  { code: 'LAK', symbol: '₭' },
  { code: 'LSL', symbol: 'L' },
  { code: 'LRD', symbol: '$' },
  { code: 'LBP', symbol: '.ل.ل' },
  { code: 'LYD', symbol: '.د.ل ' },
  { code: 'MUR', symbol: '₨' },
  { code: 'MRU', symbol: 'UM' },
  { code: 'MGA', symbol: 'Ar.' },
  { code: 'MOP', symbol: '$' },
  { code: 'MKD', symbol: 'MDen' },
  { code: 'MWK', symbol: 'K' },
  { code: 'MYR', symbol: 'RM' },
  { code: 'MVR', symbol: '.ރ ' },
  { code: 'MAD', symbol: '.د.م' },
  { code: 'MXN', symbol: '$' },
  { code: 'MZN', symbol: 'MT' },
  { code: 'MDL', symbol: 'L' },
  { code: 'MNT', symbol: '₮' },
  { code: 'MMK', symbol: 'K' },
  { code: 'NAD', symbol: 'N$' },
  { code: 'NPR', symbol: '₨' },
  { code: 'NGN', symbol: '₦' },
  { code: 'NIO', symbol: '$' },
  { code: 'AED', symbol: '.د.إ ' },
  { code: 'OMR', symbol: '﷼' },
  { code: 'PKR', symbol: '₨' },
  { code: 'PAB', symbol: 'B/.' },
  { code: 'PGK', symbol: 'K' },
  { code: 'PYG', symbol: '₲' },
  { code: 'PEN', symbol: 'S/' },
  { code: 'RUB', symbol: '₽' },
  { code: 'RWF', symbol: '₣' },
  { code: 'RON', symbol: 'L' },
  { code: 'SVC', symbol: '₡' },
  { code: 'BTC', symbol: '₿' },
  { code: 'WST', symbol: '$' },
  { code: 'STN', symbol: 'Db' },
  { code: 'SAR', symbol: '﷼ ' },
  { code: 'SHP', symbol: '£' },
  { code: 'SCR', symbol: '₨' },
  { code: 'XOF', symbol: '₣' },
  { code: 'XCD', symbol: '$' },
  { code: 'RSD', symbol: 'din' },
  { code: 'SGD', symbol: '$' },
  { code: 'ANG', symbol: 'ƒ' },
  { code: 'SYP', symbol: '.ل.س' },
  { code: 'SBD', symbol: '$' },
  { code: 'SOS', symbol: 'S' },
  { code: 'SDG', symbol: '£' },
  { code: 'SRD', symbol: '$' },
  { code: 'SLL', symbol: 'Le' },
  { code: 'TJS', symbol: 'с.' },
  { code: 'TWD', symbol: 'NT$' },
  { code: 'TZS', symbol: 'TSh' },
  { code: 'NZD', symbol: '$' },
  { code: 'TOP', symbol: '$' },
  { code: 'TTD', symbol: '$' },
  { code: 'AUD', symbol: '$' },
  { code: 'TND', symbol: '.د' },
  { code: 'TMT', symbol: 'm' },
  { code: 'TRY', symbol: '₺' },
  { code: 'UGX', symbol: 'USh' },
  { code: 'UZS', symbol: 'so’m' },
  { code: 'UAH', symbol: '₴' },
  { code: 'XPF', symbol: '₣' },
  { code: 'UYU', symbol: '$' },
  { code: 'FJD', symbol: '$' },
  { code: 'PHP', symbol: '₱' },
  { code: 'FKP', symbol: '£' },
  { code: 'HRK', symbol: 'Kn' },
  { code: 'XAF', symbol: '₣' },
  { code: 'CZK', symbol: 'Kč' },
  { code: 'CLP', symbol: '$' },
  { code: 'NOK', symbol: 'kr' },
  { code: 'LKR', symbol: '₨' },
  { code: 'CHF', symbol: '₣' },
  { code: 'ERN', symbol: 'Nfk' },
  { code: 'SZL', symbol: 'L' },
  { code: 'ETB', symbol: 'Br' },
  { code: 'ZAR', symbol: 'R' },
  { code: 'SSP', symbol: 'Db' },
  { code: 'JMD', symbol: '$' },
  { code: 'JPY', symbol: '¥' },
];
